<template>
  <div
    :class="[
      'away-container',
      {
        'transform-180': isActiveFaceToFace,
        'is-side-by-side': !isActiveFaceToFace,
      },
    ]"
  >
    <div class="language-wrapper partner-lang-wrap">
      <SingleButtonToggleLanguage :language-chosen="languageAway" :speaker-nickname area="away" />
    </div>
    <ContainerChatAutoScroll class="chat-away-container">
      <SingleMessageChat v-for="message in messageList" :key="message.callLogId" :message area="away" />
    </ContainerChatAutoScroll>
  </div>
</template>

<script setup lang="ts">
import { computed, inject, provide, Ref } from 'vue';
import { useI18n } from 'vue-i18n';

import SingleButtonToggleLanguage from '@/components/domains/chat/chat-single/SingleButtonToggleLanguage.vue';
import SingleMessageChat from '@/components/domains/chat/chat-single/SingleMessageChat.vue';
import ContainerChatAutoScroll from '@/components/shared/composite/ContainerChatAutoScroll.vue';
import { useMessagesSingle } from '@/composables/domains/chat/useMessagesSingle';
import { Language } from '@/types/common';
import { ij_isActiveFaceToFace, ij_languageArea, ij_languageAway } from '@/utils/injectionKeys.js';

const { messages } = useI18n();

const isActiveFaceToFace = inject<Ref<boolean>>(ij_isActiveFaceToFace);
const languageAway = inject(ij_languageAway) as Ref<Language>;

const { messageList } = useMessagesSingle();

// 발화자 닉네임
const speakerNickname = computed((): string => {
  return String(messages.value?.[languageAway.value?.code]?.['single-nickname-away']);
});

provide(
  ij_languageArea,
  computed(() => languageAway.value.code)
);
</script>

<style scoped lang="scss">
.chat-away-container {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

.transform-180 {
  transform: rotate(180deg);
}

.away-container {
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  min-height: 0;
  gap: 0.5rem;
  overflow-y: auto;
}

.language-wrapper {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  padding-left: 1rem;
  padding-right: 1rem;
}

.is-side-by-side {
  padding-top: 0.5rem;
}
</style>
